/**
 * @legacy
 * @prev core/templates/{base_css.html, base_js.html}
 */
import '../../ui/legacy/common'

/**
 * @legacy
 * @prev {% render_bundle 'commonLibsStyleSheets' %}
 * @prev assets/common-libs-stylesheets.js
 */
import 'select2/select2.css'

/**
 * @legacy
 * @prev administration/templates/administration/base.html
 */
import '../../ui/legacy/css/template_style_desktop.css'
import '../../ui/legacy/css/template_style_responsive.css'
import './css/administration.css'
import '../../ui/legacy/css/select2.css'

/**
 * @legacy
 * @prev {% render_bundle 'commonLibs' %}
 * @prev assets/common-libs.js
 */
import 'select2/select2'
import Alpine from 'alpinejs'

/**
 * @legacy
 * @prev administration/templates/administration/base.html
 */
import './js/dropdown'
import '../../ui/legacy/js/multiselect'
import './js/administration'

import loader from '../../ui/legacy/img/alwaysdata-loader.gif'

/**
 * @legacy
 * @prev assets/common-libs.js
 */
Alpine.start()

/* global $ */
$(document).ready(function () {
  $('.ajax').html(`<img src="${loader}" />`)
})

document.addEventListener('DOMContentLoaded', async () => {
  const flags = JSON.parse(document.body.dataset.flags)
  /**
   * @legacy
   * @prev templates/administration/base.html#script(src=reseller.js)
   */
  flags.isReseller && (await import('./js/reseller.js'))
  /**
   * @legacy
   * @prev administration/templates/administration/reseller/*.html
   */
  flags.uiReseller && (await import('./js/ui-reseller.js'))
  /**
   * @legacy
   * @prev templates/administration/home.html#footer
   */
  flags.showFirstAccountModal &&
    $('#first-account').modal({
      show: true,
      backdrop: 'static',
      keyboard: false
    })
  flags.hasGuidedTour && (await import('./js/guide-tour.js'))
  flags.uiUpdate && (await import('./js/ui-update.js'))
  flags.echarts && (await import('./js/echarts-helpers.js'))
  flags.gridjs && (await import('./js/gridjs-helpers.js'))
  /**
   * @legacy
   */
  flags.hasAnalytics && (await import('./js/analytics.js'))
  /**
   * @legacy
   */
  flags.hasQrcode && (await import('./js/qrcode.js'))
  /**
   * @legacy
   * @prev administration/templates/administration/account/probe_create_update.html
   */
  flags.hasProbeCharts && (await import('./js/probe-charts.js'))
  /**
   * @legacy
   * @prev administration/templates/administration/account/site_create_update.html
   */
  flags.uiSite && (await import('./js/ui-site.js'))
  /**
   * @legacy
   * @prev administration/templates/administration/reseller/billing_sepa.html
   */
  flags.hasSepa && (await import('./js/sepa.js'))
  /**
   * @legacy
   * @prev administration/templates/administration/permissions_create_update.html
   */
  flags.uiPermissions && (await import('./js/ui-permissions.js'))
  /**
   * @legacy
   * @prev administration/templates/administration/reseller/ticket_create_update.html
   */
  flags.uiTicket && (await import('./js/ui-ticket'))
  /**
   * @legacy
   * @prev administration/templates/administration/log_*.html
   */
  flags.uiLog && (await import('./js/ui-log'))
  /**
   * @legacy
   * @prev administration/templates/administration/task_*.html
   */
  flags.uiTask && (await import('./js/ui-task'))
  /**
   * @legacy
   * @prev administration/templates/administration/message_*.html
   */
  flags.uiMessage && (await import('./js/ui-message'))
  /**
   * @legacy
   * @prev administration/templates/administration/server/*.html
   */
  flags.uiServer && (await import('./js/ui-server'))
  /**
   * @legacy
   * @prev administration/templates/administration/transaction_*.html
   */
  flags.uiTransaction && (await import('./js/ui-transaction'))
  /**
   * @legacy
   * @prev administration/templates/administration/account/*_list.html
   */
  flags.uiAccountList && (await import('./js/ui-account-list'))
  /**
   * @legacy
   * @prev administration/templates/administration/account/domain_*.html
   */
  flags.uiDomain && (await import('./js/ui-domain'))
  /**
   * @legacy
   * @prev administration/templates/administration/account/job_*.html
   */
  flags.uiJob && (await import('./js/ui-job'))
  /**
   * @legacy
   * @prev administration/templates/administration/{support_ticket_create_update,reseller/ticket_create_update,operation_read}.html
   */
  flags.highlightCode && (await import('../../ui/legacy/js/highlight.js'))
})
